import { useSelector } from 'react-redux';
import { getResources } from './index';

export const useResources = () => useSelector(getResources);
